module.exports = __webpack_public_path__ + "assets/img/f014c10bffd9a8fc97f18e5698fea0ab.svg";